import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _ccd03fd0 = () => interopDefault(import('../src/pages/apply/index.vue' /* webpackChunkName: "pages/apply/index" */))
const _1c7b7aec = () => interopDefault(import('../src/pages/contact/index.vue' /* webpackChunkName: "pages/contact/index" */))
const _fd489f98 = () => interopDefault(import('../src/pages/download/index.vue' /* webpackChunkName: "pages/download/index" */))
const _4dd992f6 = () => interopDefault(import('../src/pages/logout/index.vue' /* webpackChunkName: "pages/logout/index" */))
const _0ac3e246 = () => interopDefault(import('../src/pages/my-planner/index.vue' /* webpackChunkName: "pages/my-planner/index" */))
const _315062ec = () => interopDefault(import('../src/pages/account/create/index.vue' /* webpackChunkName: "pages/account/create/index" */))
const _4f8180ed = () => interopDefault(import('../src/pages/account/expired/index.vue' /* webpackChunkName: "pages/account/expired/index" */))
const _7224832e = () => interopDefault(import('../src/pages/account/frozen/index.vue' /* webpackChunkName: "pages/account/frozen/index" */))
const _c10f9b64 = () => interopDefault(import('../src/pages/account/not-active/index.vue' /* webpackChunkName: "pages/account/not-active/index" */))
const _6798b6b0 = () => interopDefault(import('../src/pages/account/overdue/index.vue' /* webpackChunkName: "pages/account/overdue/index" */))
const _456c74e3 = () => interopDefault(import('../src/pages/account/suspended/index.vue' /* webpackChunkName: "pages/account/suspended/index" */))
const _19ec26d4 = () => interopDefault(import('../src/pages/account/verified/index.vue' /* webpackChunkName: "pages/account/verified/index" */))
const _37893dc7 = () => interopDefault(import('../src/pages/account/verify/index.vue' /* webpackChunkName: "pages/account/verify/index" */))
const _2cc2e2f8 = () => interopDefault(import('../src/pages/apply/submitted/index.vue' /* webpackChunkName: "pages/apply/submitted/index" */))
const _6ae3e14e = () => interopDefault(import('../config/authPage.js' /* webpackChunkName: "" */))
const _f2bbfc86 = () => interopDefault(import('../src/pages/bedrooms/availability/index.vue' /* webpackChunkName: "pages/bedrooms/availability/index" */))
const _6c7eb1ec = () => interopDefault(import('../src/pages/bedrooms/search/index.vue' /* webpackChunkName: "pages/bedrooms/search/index" */))
const _8490a306 = () => interopDefault(import('../src/pages/introduction/analytics/index.vue' /* webpackChunkName: "pages/introduction/analytics/index" */))
const _c61b0754 = () => interopDefault(import('../src/pages/introduction/appointment/index.vue' /* webpackChunkName: "pages/introduction/appointment/index" */))
const _06039406 = () => interopDefault(import('../src/pages/introduction/calendar/index.vue' /* webpackChunkName: "pages/introduction/calendar/index" */))
const _2a373216 = () => interopDefault(import('../src/pages/introduction/schedule/index.vue' /* webpackChunkName: "pages/introduction/schedule/index" */))
const _81bac584 = () => interopDefault(import('../src/pages/introduction/terms/index.vue' /* webpackChunkName: "pages/introduction/terms/index" */))
const _02e29b4e = () => interopDefault(import('../src/pages/introduction/welcome/index.vue' /* webpackChunkName: "pages/introduction/welcome/index" */))
const _6f476f17 = () => interopDefault(import('../src/pages/invite/accepted/index.vue' /* webpackChunkName: "pages/invite/accepted/index" */))
const _0f2e0ede = () => interopDefault(import('../src/pages/invite/declined/index.vue' /* webpackChunkName: "pages/invite/declined/index" */))
const _ebbe0b94 = () => interopDefault(import('../src/pages/invite/unavailable/index.vue' /* webpackChunkName: "pages/invite/unavailable/index" */))
const _ece6c214 = () => interopDefault(import('../src/pages/settings/applications.vue' /* webpackChunkName: "pages/settings/applications" */))
const _6497f5de = () => interopDefault(import('../src/pages/settings/calendar.vue' /* webpackChunkName: "pages/settings/calendar" */))
const _6cbd3134 = () => interopDefault(import('../src/pages/settings/houses.vue' /* webpackChunkName: "pages/settings/houses" */))
const _7373690c = () => interopDefault(import('../src/pages/settings/member-benefits.vue' /* webpackChunkName: "pages/settings/member-benefits" */))
const _2cb9e2e9 = () => interopDefault(import('../src/pages/settings/membership.vue' /* webpackChunkName: "pages/settings/membership" */))
const _0485cdee = () => interopDefault(import('../src/pages/settings/password.vue' /* webpackChunkName: "pages/settings/password" */))
const _77f65046 = () => interopDefault(import('../src/pages/settings/payment/index.vue' /* webpackChunkName: "pages/settings/payment/index" */))
const _bbdf7d16 = () => interopDefault(import('../src/pages/settings/preferences.vue' /* webpackChunkName: "pages/settings/preferences" */))
const _0792680d = () => interopDefault(import('../src/pages/settings/previous-bookings.vue' /* webpackChunkName: "pages/settings/previous-bookings" */))
const _0dde33b4 = () => interopDefault(import('../src/pages/settings/profile.vue' /* webpackChunkName: "pages/settings/profile" */))
const _d493db46 = () => interopDefault(import('../src/pages/account/verify/expired/index.vue' /* webpackChunkName: "pages/account/verify/expired/index" */))
const _7dcd10ce = () => interopDefault(import('../src/pages/account/verify/resend/index.vue' /* webpackChunkName: "pages/account/verify/resend/index" */))
const _bec3e15e = () => interopDefault(import('../src/pages/bedrooms/availability/book/index.vue' /* webpackChunkName: "pages/bedrooms/availability/book/index" */))
const _bc9131e8 = () => interopDefault(import('../src/pages/settings/payment/add-method/index.vue' /* webpackChunkName: "pages/settings/payment/add-method/index" */))
const _ac104278 = () => interopDefault(import('../src/pages/settings/payment/callback/index.vue' /* webpackChunkName: "pages/settings/payment/callback/index" */))
const _02218d47 = () => interopDefault(import('../src/pages/bedrooms/bookings/_id/index.vue' /* webpackChunkName: "pages/bedrooms/bookings/_id/index" */))
const _279f45c2 = () => interopDefault(import('../src/pages/bedrooms/promotion/_id/index.vue' /* webpackChunkName: "pages/bedrooms/promotion/_id/index" */))
const _216f0bf2 = () => interopDefault(import('../src/pages/whats-on/details/_id/index.vue' /* webpackChunkName: "pages/whats-on/details/_id/index" */))
const _4582d798 = () => interopDefault(import('../src/pages/bedrooms/bookings/_id/cancel/index.vue' /* webpackChunkName: "pages/bedrooms/bookings/_id/cancel/index" */))
const _5aec51d8 = () => interopDefault(import('../src/pages/bedrooms/bookings/_id/modify/index.vue' /* webpackChunkName: "pages/bedrooms/bookings/_id/modify/index" */))
const _2b9df2da = () => interopDefault(import('../src/pages/bedrooms/bookings/_id/cancel/cancelled/index.vue' /* webpackChunkName: "pages/bedrooms/bookings/_id/cancel/cancelled/index" */))
const _7e3fcbf0 = () => interopDefault(import('../src/pages/bedrooms/bookings/_id/modify/availability/index.vue' /* webpackChunkName: "pages/bedrooms/bookings/_id/modify/availability/index" */))
const _dd2b2434 = () => interopDefault(import('../src/pages/bedrooms/bookings/_id/modify/availability/book/index.vue' /* webpackChunkName: "pages/bedrooms/bookings/_id/modify/availability/book/index" */))
const _3db85220 = () => interopDefault(import('../src/pages/invite/_id/index.vue' /* webpackChunkName: "pages/invite/_id/index" */))
const _efbe48b8 = () => interopDefault(import('../src/pages/member-benefits/_id/index.vue' /* webpackChunkName: "pages/member-benefits/_id/index" */))
const _2c6805f3 = () => interopDefault(import('../src/pages/whats-on/_type/index.vue' /* webpackChunkName: "pages/whats-on/_type/index" */))
const _d80c47b2 = () => interopDefault(import('../src/pages/apply/_id/basics/index.vue' /* webpackChunkName: "pages/apply/_id/basics/index" */))
const _699c5b14 = () => interopDefault(import('../src/pages/apply/_id/details/index.vue' /* webpackChunkName: "pages/apply/_id/details/index" */))
const _28e65f7a = () => interopDefault(import('../src/pages/apply/_id/package/index.vue' /* webpackChunkName: "pages/apply/_id/package/index" */))
const _02e00448 = () => interopDefault(import('../src/pages/apply/_id/pay/index.vue' /* webpackChunkName: "pages/apply/_id/pay/index" */))
const _1d14d5ba = () => interopDefault(import('../src/pages/apply/_id/review/index.vue' /* webpackChunkName: "pages/apply/_id/review/index" */))
const _1d49c5aa = () => interopDefault(import('../src/pages/apply/_id/rules/index.vue' /* webpackChunkName: "pages/apply/_id/rules/index" */))
const _562bca28 = () => interopDefault(import('../src/pages/invite/_id/landing/index.vue' /* webpackChunkName: "pages/invite/_id/landing/index" */))
const _43f919ee = () => interopDefault(import('../src/pages/apply/_id/pay/callback/index.vue' /* webpackChunkName: "pages/apply/_id/pay/callback/index" */))
const _2b6b8946 = () => interopDefault(import('../src/pages/_.vue' /* webpackChunkName: "pages/_" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/apply",
    component: _ccd03fd0,
    name: "apply___en"
  }, {
    path: "/contact",
    component: _1c7b7aec,
    name: "contact___en"
  }, {
    path: "/download",
    component: _fd489f98,
    name: "download___en"
  }, {
    path: "/logout",
    component: _4dd992f6,
    name: "logout___en"
  }, {
    path: "/my-planner",
    component: _0ac3e246,
    name: "my-planner___en"
  }, {
    path: "/account/create",
    component: _315062ec,
    name: "account-create___en"
  }, {
    path: "/account/expired",
    component: _4f8180ed,
    name: "account-expired___en"
  }, {
    path: "/account/frozen",
    component: _7224832e,
    name: "account-frozen___en"
  }, {
    path: "/account/not-active",
    component: _c10f9b64,
    name: "account-not-active___en"
  }, {
    path: "/account/overdue",
    component: _6798b6b0,
    name: "account-overdue___en"
  }, {
    path: "/account/suspended",
    component: _456c74e3,
    name: "account-suspended___en"
  }, {
    path: "/account/verified",
    component: _19ec26d4,
    name: "account-verified___en"
  }, {
    path: "/account/verify",
    component: _37893dc7,
    name: "account-verify___en"
  }, {
    path: "/apply/submitted",
    component: _2cc2e2f8,
    name: "apply-submitted___en"
  }, {
    path: "/auth/login",
    component: _6ae3e14e,
    name: "oauth-login___en"
  }, {
    path: "/auth/logout",
    component: _6ae3e14e,
    name: "oauth-logout___en"
  }, {
    path: "/bedrooms/availability",
    component: _f2bbfc86,
    name: "bedrooms-availability___en"
  }, {
    path: "/bedrooms/search",
    component: _6c7eb1ec,
    name: "bedrooms-search___en"
  }, {
    path: "/ca/apply",
    component: _ccd03fd0,
    name: "apply___ca"
  }, {
    path: "/ca/contact",
    component: _1c7b7aec,
    name: "contact___ca"
  }, {
    path: "/ca/download",
    component: _fd489f98,
    name: "download___ca"
  }, {
    path: "/ca/logout",
    component: _4dd992f6,
    name: "logout___ca"
  }, {
    path: "/ca/my-planner",
    component: _0ac3e246,
    name: "my-planner___ca"
  }, {
    path: "/de/apply",
    component: _ccd03fd0,
    name: "apply___de"
  }, {
    path: "/de/contact",
    component: _1c7b7aec,
    name: "contact___de"
  }, {
    path: "/de/download",
    component: _fd489f98,
    name: "download___de"
  }, {
    path: "/de/logout",
    component: _4dd992f6,
    name: "logout___de"
  }, {
    path: "/de/my-planner",
    component: _0ac3e246,
    name: "my-planner___de"
  }, {
    path: "/en-us/apply",
    component: _ccd03fd0,
    name: "apply___en-us"
  }, {
    path: "/en-us/contact",
    component: _1c7b7aec,
    name: "contact___en-us"
  }, {
    path: "/en-us/download",
    component: _fd489f98,
    name: "download___en-us"
  }, {
    path: "/en-us/logout",
    component: _4dd992f6,
    name: "logout___en-us"
  }, {
    path: "/en-us/my-planner",
    component: _0ac3e246,
    name: "my-planner___en-us"
  }, {
    path: "/es/apply",
    component: _ccd03fd0,
    name: "apply___es"
  }, {
    path: "/es/contact",
    component: _1c7b7aec,
    name: "contact___es"
  }, {
    path: "/es/download",
    component: _fd489f98,
    name: "download___es"
  }, {
    path: "/es/logout",
    component: _4dd992f6,
    name: "logout___es"
  }, {
    path: "/es/my-planner",
    component: _0ac3e246,
    name: "my-planner___es"
  }, {
    path: "/fr/apply",
    component: _ccd03fd0,
    name: "apply___fr"
  }, {
    path: "/fr/contact",
    component: _1c7b7aec,
    name: "contact___fr"
  }, {
    path: "/fr/download",
    component: _fd489f98,
    name: "download___fr"
  }, {
    path: "/fr/logout",
    component: _4dd992f6,
    name: "logout___fr"
  }, {
    path: "/fr/my-planner",
    component: _0ac3e246,
    name: "my-planner___fr"
  }, {
    path: "/introduction/analytics",
    component: _8490a306,
    name: "introduction-analytics___en"
  }, {
    path: "/introduction/appointment",
    component: _c61b0754,
    name: "introduction-appointment___en"
  }, {
    path: "/introduction/calendar",
    component: _06039406,
    name: "introduction-calendar___en"
  }, {
    path: "/introduction/schedule",
    component: _2a373216,
    name: "introduction-schedule___en"
  }, {
    path: "/introduction/terms",
    component: _81bac584,
    name: "introduction-terms___en"
  }, {
    path: "/introduction/welcome",
    component: _02e29b4e,
    name: "introduction-welcome___en"
  }, {
    path: "/invite/accepted",
    component: _6f476f17,
    name: "invite-accepted___en"
  }, {
    path: "/invite/declined",
    component: _0f2e0ede,
    name: "invite-declined___en"
  }, {
    path: "/invite/unavailable",
    component: _ebbe0b94,
    name: "invite-unavailable___en"
  }, {
    path: "/ja/apply",
    component: _ccd03fd0,
    name: "apply___ja"
  }, {
    path: "/ja/contact",
    component: _1c7b7aec,
    name: "contact___ja"
  }, {
    path: "/ja/download",
    component: _fd489f98,
    name: "download___ja"
  }, {
    path: "/ja/logout",
    component: _4dd992f6,
    name: "logout___ja"
  }, {
    path: "/ja/my-planner",
    component: _0ac3e246,
    name: "my-planner___ja"
  }, {
    path: "/ko/apply",
    component: _ccd03fd0,
    name: "apply___ko"
  }, {
    path: "/ko/contact",
    component: _1c7b7aec,
    name: "contact___ko"
  }, {
    path: "/ko/download",
    component: _fd489f98,
    name: "download___ko"
  }, {
    path: "/ko/logout",
    component: _4dd992f6,
    name: "logout___ko"
  }, {
    path: "/ko/my-planner",
    component: _0ac3e246,
    name: "my-planner___ko"
  }, {
    path: "/settings/applications",
    component: _ece6c214,
    name: "settings-applications___en"
  }, {
    path: "/settings/calendar",
    component: _6497f5de,
    name: "settings-calendar___en"
  }, {
    path: "/settings/houses",
    component: _6cbd3134,
    name: "settings-houses___en"
  }, {
    path: "/settings/member-benefits",
    component: _7373690c,
    name: "settings-member-benefits___en"
  }, {
    path: "/settings/membership",
    component: _2cb9e2e9,
    name: "settings-membership___en"
  }, {
    path: "/settings/password",
    component: _0485cdee,
    name: "settings-password___en"
  }, {
    path: "/settings/payment",
    component: _77f65046,
    name: "settings-payment___en"
  }, {
    path: "/settings/preferences",
    component: _bbdf7d16,
    name: "settings-preferences___en"
  }, {
    path: "/settings/previous-bookings",
    component: _0792680d,
    name: "settings-previous-bookings___en"
  }, {
    path: "/settings/profile",
    component: _0dde33b4,
    name: "settings-profile___en"
  }, {
    path: "/tr/apply",
    component: _ccd03fd0,
    name: "apply___tr"
  }, {
    path: "/tr/contact",
    component: _1c7b7aec,
    name: "contact___tr"
  }, {
    path: "/tr/download",
    component: _fd489f98,
    name: "download___tr"
  }, {
    path: "/tr/logout",
    component: _4dd992f6,
    name: "logout___tr"
  }, {
    path: "/tr/my-planner",
    component: _0ac3e246,
    name: "my-planner___tr"
  }, {
    path: "/zh/apply",
    component: _ccd03fd0,
    name: "apply___zh"
  }, {
    path: "/zh/contact",
    component: _1c7b7aec,
    name: "contact___zh"
  }, {
    path: "/zh/download",
    component: _fd489f98,
    name: "download___zh"
  }, {
    path: "/zh/logout",
    component: _4dd992f6,
    name: "logout___zh"
  }, {
    path: "/zh/my-planner",
    component: _0ac3e246,
    name: "my-planner___zh"
  }, {
    path: "/account/verify/expired",
    component: _d493db46,
    name: "account-verify-expired___en"
  }, {
    path: "/account/verify/resend",
    component: _7dcd10ce,
    name: "account-verify-resend___en"
  }, {
    path: "/bedrooms/availability/book",
    component: _bec3e15e,
    name: "bedrooms-availability-book___en"
  }, {
    path: "/ca/account/create",
    component: _315062ec,
    name: "account-create___ca"
  }, {
    path: "/ca/account/expired",
    component: _4f8180ed,
    name: "account-expired___ca"
  }, {
    path: "/ca/account/frozen",
    component: _7224832e,
    name: "account-frozen___ca"
  }, {
    path: "/ca/account/not-active",
    component: _c10f9b64,
    name: "account-not-active___ca"
  }, {
    path: "/ca/account/overdue",
    component: _6798b6b0,
    name: "account-overdue___ca"
  }, {
    path: "/ca/account/suspended",
    component: _456c74e3,
    name: "account-suspended___ca"
  }, {
    path: "/ca/account/verified",
    component: _19ec26d4,
    name: "account-verified___ca"
  }, {
    path: "/ca/account/verify",
    component: _37893dc7,
    name: "account-verify___ca"
  }, {
    path: "/ca/apply/submitted",
    component: _2cc2e2f8,
    name: "apply-submitted___ca"
  }, {
    path: "/ca/auth/login",
    component: _6ae3e14e,
    name: "oauth-login___ca"
  }, {
    path: "/ca/auth/logout",
    component: _6ae3e14e,
    name: "oauth-logout___ca"
  }, {
    path: "/ca/bedrooms/availability",
    component: _f2bbfc86,
    name: "bedrooms-availability___ca"
  }, {
    path: "/ca/bedrooms/search",
    component: _6c7eb1ec,
    name: "bedrooms-search___ca"
  }, {
    path: "/ca/introduction/analytics",
    component: _8490a306,
    name: "introduction-analytics___ca"
  }, {
    path: "/ca/introduction/appointment",
    component: _c61b0754,
    name: "introduction-appointment___ca"
  }, {
    path: "/ca/introduction/calendar",
    component: _06039406,
    name: "introduction-calendar___ca"
  }, {
    path: "/ca/introduction/schedule",
    component: _2a373216,
    name: "introduction-schedule___ca"
  }, {
    path: "/ca/introduction/terms",
    component: _81bac584,
    name: "introduction-terms___ca"
  }, {
    path: "/ca/introduction/welcome",
    component: _02e29b4e,
    name: "introduction-welcome___ca"
  }, {
    path: "/ca/invite/accepted",
    component: _6f476f17,
    name: "invite-accepted___ca"
  }, {
    path: "/ca/invite/declined",
    component: _0f2e0ede,
    name: "invite-declined___ca"
  }, {
    path: "/ca/invite/unavailable",
    component: _ebbe0b94,
    name: "invite-unavailable___ca"
  }, {
    path: "/ca/settings/applications",
    component: _ece6c214,
    name: "settings-applications___ca"
  }, {
    path: "/ca/settings/calendar",
    component: _6497f5de,
    name: "settings-calendar___ca"
  }, {
    path: "/ca/settings/houses",
    component: _6cbd3134,
    name: "settings-houses___ca"
  }, {
    path: "/ca/settings/member-benefits",
    component: _7373690c,
    name: "settings-member-benefits___ca"
  }, {
    path: "/ca/settings/membership",
    component: _2cb9e2e9,
    name: "settings-membership___ca"
  }, {
    path: "/ca/settings/password",
    component: _0485cdee,
    name: "settings-password___ca"
  }, {
    path: "/ca/settings/payment",
    component: _77f65046,
    name: "settings-payment___ca"
  }, {
    path: "/ca/settings/preferences",
    component: _bbdf7d16,
    name: "settings-preferences___ca"
  }, {
    path: "/ca/settings/previous-bookings",
    component: _0792680d,
    name: "settings-previous-bookings___ca"
  }, {
    path: "/ca/settings/profile",
    component: _0dde33b4,
    name: "settings-profile___ca"
  }, {
    path: "/de/account/create",
    component: _315062ec,
    name: "account-create___de"
  }, {
    path: "/de/account/expired",
    component: _4f8180ed,
    name: "account-expired___de"
  }, {
    path: "/de/account/frozen",
    component: _7224832e,
    name: "account-frozen___de"
  }, {
    path: "/de/account/not-active",
    component: _c10f9b64,
    name: "account-not-active___de"
  }, {
    path: "/de/account/overdue",
    component: _6798b6b0,
    name: "account-overdue___de"
  }, {
    path: "/de/account/suspended",
    component: _456c74e3,
    name: "account-suspended___de"
  }, {
    path: "/de/account/verified",
    component: _19ec26d4,
    name: "account-verified___de"
  }, {
    path: "/de/account/verify",
    component: _37893dc7,
    name: "account-verify___de"
  }, {
    path: "/de/apply/submitted",
    component: _2cc2e2f8,
    name: "apply-submitted___de"
  }, {
    path: "/de/auth/login",
    component: _6ae3e14e,
    name: "oauth-login___de"
  }, {
    path: "/de/auth/logout",
    component: _6ae3e14e,
    name: "oauth-logout___de"
  }, {
    path: "/de/bedrooms/availability",
    component: _f2bbfc86,
    name: "bedrooms-availability___de"
  }, {
    path: "/de/bedrooms/search",
    component: _6c7eb1ec,
    name: "bedrooms-search___de"
  }, {
    path: "/de/introduction/analytics",
    component: _8490a306,
    name: "introduction-analytics___de"
  }, {
    path: "/de/introduction/appointment",
    component: _c61b0754,
    name: "introduction-appointment___de"
  }, {
    path: "/de/introduction/calendar",
    component: _06039406,
    name: "introduction-calendar___de"
  }, {
    path: "/de/introduction/schedule",
    component: _2a373216,
    name: "introduction-schedule___de"
  }, {
    path: "/de/introduction/terms",
    component: _81bac584,
    name: "introduction-terms___de"
  }, {
    path: "/de/introduction/welcome",
    component: _02e29b4e,
    name: "introduction-welcome___de"
  }, {
    path: "/de/invite/accepted",
    component: _6f476f17,
    name: "invite-accepted___de"
  }, {
    path: "/de/invite/declined",
    component: _0f2e0ede,
    name: "invite-declined___de"
  }, {
    path: "/de/invite/unavailable",
    component: _ebbe0b94,
    name: "invite-unavailable___de"
  }, {
    path: "/de/settings/applications",
    component: _ece6c214,
    name: "settings-applications___de"
  }, {
    path: "/de/settings/calendar",
    component: _6497f5de,
    name: "settings-calendar___de"
  }, {
    path: "/de/settings/houses",
    component: _6cbd3134,
    name: "settings-houses___de"
  }, {
    path: "/de/settings/member-benefits",
    component: _7373690c,
    name: "settings-member-benefits___de"
  }, {
    path: "/de/settings/membership",
    component: _2cb9e2e9,
    name: "settings-membership___de"
  }, {
    path: "/de/settings/password",
    component: _0485cdee,
    name: "settings-password___de"
  }, {
    path: "/de/settings/payment",
    component: _77f65046,
    name: "settings-payment___de"
  }, {
    path: "/de/settings/preferences",
    component: _bbdf7d16,
    name: "settings-preferences___de"
  }, {
    path: "/de/settings/previous-bookings",
    component: _0792680d,
    name: "settings-previous-bookings___de"
  }, {
    path: "/de/settings/profile",
    component: _0dde33b4,
    name: "settings-profile___de"
  }, {
    path: "/en-us/account/create",
    component: _315062ec,
    name: "account-create___en-us"
  }, {
    path: "/en-us/account/expired",
    component: _4f8180ed,
    name: "account-expired___en-us"
  }, {
    path: "/en-us/account/frozen",
    component: _7224832e,
    name: "account-frozen___en-us"
  }, {
    path: "/en-us/account/not-active",
    component: _c10f9b64,
    name: "account-not-active___en-us"
  }, {
    path: "/en-us/account/overdue",
    component: _6798b6b0,
    name: "account-overdue___en-us"
  }, {
    path: "/en-us/account/suspended",
    component: _456c74e3,
    name: "account-suspended___en-us"
  }, {
    path: "/en-us/account/verified",
    component: _19ec26d4,
    name: "account-verified___en-us"
  }, {
    path: "/en-us/account/verify",
    component: _37893dc7,
    name: "account-verify___en-us"
  }, {
    path: "/en-us/apply/submitted",
    component: _2cc2e2f8,
    name: "apply-submitted___en-us"
  }, {
    path: "/en-us/auth/login",
    component: _6ae3e14e,
    name: "oauth-login___en-us"
  }, {
    path: "/en-us/auth/logout",
    component: _6ae3e14e,
    name: "oauth-logout___en-us"
  }, {
    path: "/en-us/bedrooms/availability",
    component: _f2bbfc86,
    name: "bedrooms-availability___en-us"
  }, {
    path: "/en-us/bedrooms/search",
    component: _6c7eb1ec,
    name: "bedrooms-search___en-us"
  }, {
    path: "/en-us/introduction/analytics",
    component: _8490a306,
    name: "introduction-analytics___en-us"
  }, {
    path: "/en-us/introduction/appointment",
    component: _c61b0754,
    name: "introduction-appointment___en-us"
  }, {
    path: "/en-us/introduction/calendar",
    component: _06039406,
    name: "introduction-calendar___en-us"
  }, {
    path: "/en-us/introduction/schedule",
    component: _2a373216,
    name: "introduction-schedule___en-us"
  }, {
    path: "/en-us/introduction/terms",
    component: _81bac584,
    name: "introduction-terms___en-us"
  }, {
    path: "/en-us/introduction/welcome",
    component: _02e29b4e,
    name: "introduction-welcome___en-us"
  }, {
    path: "/en-us/invite/accepted",
    component: _6f476f17,
    name: "invite-accepted___en-us"
  }, {
    path: "/en-us/invite/declined",
    component: _0f2e0ede,
    name: "invite-declined___en-us"
  }, {
    path: "/en-us/invite/unavailable",
    component: _ebbe0b94,
    name: "invite-unavailable___en-us"
  }, {
    path: "/en-us/settings/applications",
    component: _ece6c214,
    name: "settings-applications___en-us"
  }, {
    path: "/en-us/settings/calendar",
    component: _6497f5de,
    name: "settings-calendar___en-us"
  }, {
    path: "/en-us/settings/houses",
    component: _6cbd3134,
    name: "settings-houses___en-us"
  }, {
    path: "/en-us/settings/member-benefits",
    component: _7373690c,
    name: "settings-member-benefits___en-us"
  }, {
    path: "/en-us/settings/membership",
    component: _2cb9e2e9,
    name: "settings-membership___en-us"
  }, {
    path: "/en-us/settings/password",
    component: _0485cdee,
    name: "settings-password___en-us"
  }, {
    path: "/en-us/settings/payment",
    component: _77f65046,
    name: "settings-payment___en-us"
  }, {
    path: "/en-us/settings/preferences",
    component: _bbdf7d16,
    name: "settings-preferences___en-us"
  }, {
    path: "/en-us/settings/previous-bookings",
    component: _0792680d,
    name: "settings-previous-bookings___en-us"
  }, {
    path: "/en-us/settings/profile",
    component: _0dde33b4,
    name: "settings-profile___en-us"
  }, {
    path: "/es/account/create",
    component: _315062ec,
    name: "account-create___es"
  }, {
    path: "/es/account/expired",
    component: _4f8180ed,
    name: "account-expired___es"
  }, {
    path: "/es/account/frozen",
    component: _7224832e,
    name: "account-frozen___es"
  }, {
    path: "/es/account/not-active",
    component: _c10f9b64,
    name: "account-not-active___es"
  }, {
    path: "/es/account/overdue",
    component: _6798b6b0,
    name: "account-overdue___es"
  }, {
    path: "/es/account/suspended",
    component: _456c74e3,
    name: "account-suspended___es"
  }, {
    path: "/es/account/verified",
    component: _19ec26d4,
    name: "account-verified___es"
  }, {
    path: "/es/account/verify",
    component: _37893dc7,
    name: "account-verify___es"
  }, {
    path: "/es/apply/submitted",
    component: _2cc2e2f8,
    name: "apply-submitted___es"
  }, {
    path: "/es/auth/login",
    component: _6ae3e14e,
    name: "oauth-login___es"
  }, {
    path: "/es/auth/logout",
    component: _6ae3e14e,
    name: "oauth-logout___es"
  }, {
    path: "/es/bedrooms/availability",
    component: _f2bbfc86,
    name: "bedrooms-availability___es"
  }, {
    path: "/es/bedrooms/search",
    component: _6c7eb1ec,
    name: "bedrooms-search___es"
  }, {
    path: "/es/introduction/analytics",
    component: _8490a306,
    name: "introduction-analytics___es"
  }, {
    path: "/es/introduction/appointment",
    component: _c61b0754,
    name: "introduction-appointment___es"
  }, {
    path: "/es/introduction/calendar",
    component: _06039406,
    name: "introduction-calendar___es"
  }, {
    path: "/es/introduction/schedule",
    component: _2a373216,
    name: "introduction-schedule___es"
  }, {
    path: "/es/introduction/terms",
    component: _81bac584,
    name: "introduction-terms___es"
  }, {
    path: "/es/introduction/welcome",
    component: _02e29b4e,
    name: "introduction-welcome___es"
  }, {
    path: "/es/invite/accepted",
    component: _6f476f17,
    name: "invite-accepted___es"
  }, {
    path: "/es/invite/declined",
    component: _0f2e0ede,
    name: "invite-declined___es"
  }, {
    path: "/es/invite/unavailable",
    component: _ebbe0b94,
    name: "invite-unavailable___es"
  }, {
    path: "/es/settings/applications",
    component: _ece6c214,
    name: "settings-applications___es"
  }, {
    path: "/es/settings/calendar",
    component: _6497f5de,
    name: "settings-calendar___es"
  }, {
    path: "/es/settings/houses",
    component: _6cbd3134,
    name: "settings-houses___es"
  }, {
    path: "/es/settings/member-benefits",
    component: _7373690c,
    name: "settings-member-benefits___es"
  }, {
    path: "/es/settings/membership",
    component: _2cb9e2e9,
    name: "settings-membership___es"
  }, {
    path: "/es/settings/password",
    component: _0485cdee,
    name: "settings-password___es"
  }, {
    path: "/es/settings/payment",
    component: _77f65046,
    name: "settings-payment___es"
  }, {
    path: "/es/settings/preferences",
    component: _bbdf7d16,
    name: "settings-preferences___es"
  }, {
    path: "/es/settings/previous-bookings",
    component: _0792680d,
    name: "settings-previous-bookings___es"
  }, {
    path: "/es/settings/profile",
    component: _0dde33b4,
    name: "settings-profile___es"
  }, {
    path: "/fr/account/create",
    component: _315062ec,
    name: "account-create___fr"
  }, {
    path: "/fr/account/expired",
    component: _4f8180ed,
    name: "account-expired___fr"
  }, {
    path: "/fr/account/frozen",
    component: _7224832e,
    name: "account-frozen___fr"
  }, {
    path: "/fr/account/not-active",
    component: _c10f9b64,
    name: "account-not-active___fr"
  }, {
    path: "/fr/account/overdue",
    component: _6798b6b0,
    name: "account-overdue___fr"
  }, {
    path: "/fr/account/suspended",
    component: _456c74e3,
    name: "account-suspended___fr"
  }, {
    path: "/fr/account/verified",
    component: _19ec26d4,
    name: "account-verified___fr"
  }, {
    path: "/fr/account/verify",
    component: _37893dc7,
    name: "account-verify___fr"
  }, {
    path: "/fr/apply/submitted",
    component: _2cc2e2f8,
    name: "apply-submitted___fr"
  }, {
    path: "/fr/auth/login",
    component: _6ae3e14e,
    name: "oauth-login___fr"
  }, {
    path: "/fr/auth/logout",
    component: _6ae3e14e,
    name: "oauth-logout___fr"
  }, {
    path: "/fr/bedrooms/availability",
    component: _f2bbfc86,
    name: "bedrooms-availability___fr"
  }, {
    path: "/fr/bedrooms/search",
    component: _6c7eb1ec,
    name: "bedrooms-search___fr"
  }, {
    path: "/fr/introduction/analytics",
    component: _8490a306,
    name: "introduction-analytics___fr"
  }, {
    path: "/fr/introduction/appointment",
    component: _c61b0754,
    name: "introduction-appointment___fr"
  }, {
    path: "/fr/introduction/calendar",
    component: _06039406,
    name: "introduction-calendar___fr"
  }, {
    path: "/fr/introduction/schedule",
    component: _2a373216,
    name: "introduction-schedule___fr"
  }, {
    path: "/fr/introduction/terms",
    component: _81bac584,
    name: "introduction-terms___fr"
  }, {
    path: "/fr/introduction/welcome",
    component: _02e29b4e,
    name: "introduction-welcome___fr"
  }, {
    path: "/fr/invite/accepted",
    component: _6f476f17,
    name: "invite-accepted___fr"
  }, {
    path: "/fr/invite/declined",
    component: _0f2e0ede,
    name: "invite-declined___fr"
  }, {
    path: "/fr/invite/unavailable",
    component: _ebbe0b94,
    name: "invite-unavailable___fr"
  }, {
    path: "/fr/settings/applications",
    component: _ece6c214,
    name: "settings-applications___fr"
  }, {
    path: "/fr/settings/calendar",
    component: _6497f5de,
    name: "settings-calendar___fr"
  }, {
    path: "/fr/settings/houses",
    component: _6cbd3134,
    name: "settings-houses___fr"
  }, {
    path: "/fr/settings/member-benefits",
    component: _7373690c,
    name: "settings-member-benefits___fr"
  }, {
    path: "/fr/settings/membership",
    component: _2cb9e2e9,
    name: "settings-membership___fr"
  }, {
    path: "/fr/settings/password",
    component: _0485cdee,
    name: "settings-password___fr"
  }, {
    path: "/fr/settings/payment",
    component: _77f65046,
    name: "settings-payment___fr"
  }, {
    path: "/fr/settings/preferences",
    component: _bbdf7d16,
    name: "settings-preferences___fr"
  }, {
    path: "/fr/settings/previous-bookings",
    component: _0792680d,
    name: "settings-previous-bookings___fr"
  }, {
    path: "/fr/settings/profile",
    component: _0dde33b4,
    name: "settings-profile___fr"
  }, {
    path: "/ja/account/create",
    component: _315062ec,
    name: "account-create___ja"
  }, {
    path: "/ja/account/expired",
    component: _4f8180ed,
    name: "account-expired___ja"
  }, {
    path: "/ja/account/frozen",
    component: _7224832e,
    name: "account-frozen___ja"
  }, {
    path: "/ja/account/not-active",
    component: _c10f9b64,
    name: "account-not-active___ja"
  }, {
    path: "/ja/account/overdue",
    component: _6798b6b0,
    name: "account-overdue___ja"
  }, {
    path: "/ja/account/suspended",
    component: _456c74e3,
    name: "account-suspended___ja"
  }, {
    path: "/ja/account/verified",
    component: _19ec26d4,
    name: "account-verified___ja"
  }, {
    path: "/ja/account/verify",
    component: _37893dc7,
    name: "account-verify___ja"
  }, {
    path: "/ja/apply/submitted",
    component: _2cc2e2f8,
    name: "apply-submitted___ja"
  }, {
    path: "/ja/auth/login",
    component: _6ae3e14e,
    name: "oauth-login___ja"
  }, {
    path: "/ja/auth/logout",
    component: _6ae3e14e,
    name: "oauth-logout___ja"
  }, {
    path: "/ja/bedrooms/availability",
    component: _f2bbfc86,
    name: "bedrooms-availability___ja"
  }, {
    path: "/ja/bedrooms/search",
    component: _6c7eb1ec,
    name: "bedrooms-search___ja"
  }, {
    path: "/ja/introduction/analytics",
    component: _8490a306,
    name: "introduction-analytics___ja"
  }, {
    path: "/ja/introduction/appointment",
    component: _c61b0754,
    name: "introduction-appointment___ja"
  }, {
    path: "/ja/introduction/calendar",
    component: _06039406,
    name: "introduction-calendar___ja"
  }, {
    path: "/ja/introduction/schedule",
    component: _2a373216,
    name: "introduction-schedule___ja"
  }, {
    path: "/ja/introduction/terms",
    component: _81bac584,
    name: "introduction-terms___ja"
  }, {
    path: "/ja/introduction/welcome",
    component: _02e29b4e,
    name: "introduction-welcome___ja"
  }, {
    path: "/ja/invite/accepted",
    component: _6f476f17,
    name: "invite-accepted___ja"
  }, {
    path: "/ja/invite/declined",
    component: _0f2e0ede,
    name: "invite-declined___ja"
  }, {
    path: "/ja/invite/unavailable",
    component: _ebbe0b94,
    name: "invite-unavailable___ja"
  }, {
    path: "/ja/settings/applications",
    component: _ece6c214,
    name: "settings-applications___ja"
  }, {
    path: "/ja/settings/calendar",
    component: _6497f5de,
    name: "settings-calendar___ja"
  }, {
    path: "/ja/settings/houses",
    component: _6cbd3134,
    name: "settings-houses___ja"
  }, {
    path: "/ja/settings/member-benefits",
    component: _7373690c,
    name: "settings-member-benefits___ja"
  }, {
    path: "/ja/settings/membership",
    component: _2cb9e2e9,
    name: "settings-membership___ja"
  }, {
    path: "/ja/settings/password",
    component: _0485cdee,
    name: "settings-password___ja"
  }, {
    path: "/ja/settings/payment",
    component: _77f65046,
    name: "settings-payment___ja"
  }, {
    path: "/ja/settings/preferences",
    component: _bbdf7d16,
    name: "settings-preferences___ja"
  }, {
    path: "/ja/settings/previous-bookings",
    component: _0792680d,
    name: "settings-previous-bookings___ja"
  }, {
    path: "/ja/settings/profile",
    component: _0dde33b4,
    name: "settings-profile___ja"
  }, {
    path: "/ko/account/create",
    component: _315062ec,
    name: "account-create___ko"
  }, {
    path: "/ko/account/expired",
    component: _4f8180ed,
    name: "account-expired___ko"
  }, {
    path: "/ko/account/frozen",
    component: _7224832e,
    name: "account-frozen___ko"
  }, {
    path: "/ko/account/not-active",
    component: _c10f9b64,
    name: "account-not-active___ko"
  }, {
    path: "/ko/account/overdue",
    component: _6798b6b0,
    name: "account-overdue___ko"
  }, {
    path: "/ko/account/suspended",
    component: _456c74e3,
    name: "account-suspended___ko"
  }, {
    path: "/ko/account/verified",
    component: _19ec26d4,
    name: "account-verified___ko"
  }, {
    path: "/ko/account/verify",
    component: _37893dc7,
    name: "account-verify___ko"
  }, {
    path: "/ko/apply/submitted",
    component: _2cc2e2f8,
    name: "apply-submitted___ko"
  }, {
    path: "/ko/auth/login",
    component: _6ae3e14e,
    name: "oauth-login___ko"
  }, {
    path: "/ko/auth/logout",
    component: _6ae3e14e,
    name: "oauth-logout___ko"
  }, {
    path: "/ko/bedrooms/availability",
    component: _f2bbfc86,
    name: "bedrooms-availability___ko"
  }, {
    path: "/ko/bedrooms/search",
    component: _6c7eb1ec,
    name: "bedrooms-search___ko"
  }, {
    path: "/ko/introduction/analytics",
    component: _8490a306,
    name: "introduction-analytics___ko"
  }, {
    path: "/ko/introduction/appointment",
    component: _c61b0754,
    name: "introduction-appointment___ko"
  }, {
    path: "/ko/introduction/calendar",
    component: _06039406,
    name: "introduction-calendar___ko"
  }, {
    path: "/ko/introduction/schedule",
    component: _2a373216,
    name: "introduction-schedule___ko"
  }, {
    path: "/ko/introduction/terms",
    component: _81bac584,
    name: "introduction-terms___ko"
  }, {
    path: "/ko/introduction/welcome",
    component: _02e29b4e,
    name: "introduction-welcome___ko"
  }, {
    path: "/ko/invite/accepted",
    component: _6f476f17,
    name: "invite-accepted___ko"
  }, {
    path: "/ko/invite/declined",
    component: _0f2e0ede,
    name: "invite-declined___ko"
  }, {
    path: "/ko/invite/unavailable",
    component: _ebbe0b94,
    name: "invite-unavailable___ko"
  }, {
    path: "/ko/settings/applications",
    component: _ece6c214,
    name: "settings-applications___ko"
  }, {
    path: "/ko/settings/calendar",
    component: _6497f5de,
    name: "settings-calendar___ko"
  }, {
    path: "/ko/settings/houses",
    component: _6cbd3134,
    name: "settings-houses___ko"
  }, {
    path: "/ko/settings/member-benefits",
    component: _7373690c,
    name: "settings-member-benefits___ko"
  }, {
    path: "/ko/settings/membership",
    component: _2cb9e2e9,
    name: "settings-membership___ko"
  }, {
    path: "/ko/settings/password",
    component: _0485cdee,
    name: "settings-password___ko"
  }, {
    path: "/ko/settings/payment",
    component: _77f65046,
    name: "settings-payment___ko"
  }, {
    path: "/ko/settings/preferences",
    component: _bbdf7d16,
    name: "settings-preferences___ko"
  }, {
    path: "/ko/settings/previous-bookings",
    component: _0792680d,
    name: "settings-previous-bookings___ko"
  }, {
    path: "/ko/settings/profile",
    component: _0dde33b4,
    name: "settings-profile___ko"
  }, {
    path: "/settings/payment/add-method",
    component: _bc9131e8,
    name: "settings-payment-add-method___en"
  }, {
    path: "/settings/payment/callback",
    component: _ac104278,
    name: "settings-payment-callback___en"
  }, {
    path: "/tr/account/create",
    component: _315062ec,
    name: "account-create___tr"
  }, {
    path: "/tr/account/expired",
    component: _4f8180ed,
    name: "account-expired___tr"
  }, {
    path: "/tr/account/frozen",
    component: _7224832e,
    name: "account-frozen___tr"
  }, {
    path: "/tr/account/not-active",
    component: _c10f9b64,
    name: "account-not-active___tr"
  }, {
    path: "/tr/account/overdue",
    component: _6798b6b0,
    name: "account-overdue___tr"
  }, {
    path: "/tr/account/suspended",
    component: _456c74e3,
    name: "account-suspended___tr"
  }, {
    path: "/tr/account/verified",
    component: _19ec26d4,
    name: "account-verified___tr"
  }, {
    path: "/tr/account/verify",
    component: _37893dc7,
    name: "account-verify___tr"
  }, {
    path: "/tr/apply/submitted",
    component: _2cc2e2f8,
    name: "apply-submitted___tr"
  }, {
    path: "/tr/auth/login",
    component: _6ae3e14e,
    name: "oauth-login___tr"
  }, {
    path: "/tr/auth/logout",
    component: _6ae3e14e,
    name: "oauth-logout___tr"
  }, {
    path: "/tr/bedrooms/availability",
    component: _f2bbfc86,
    name: "bedrooms-availability___tr"
  }, {
    path: "/tr/bedrooms/search",
    component: _6c7eb1ec,
    name: "bedrooms-search___tr"
  }, {
    path: "/tr/introduction/analytics",
    component: _8490a306,
    name: "introduction-analytics___tr"
  }, {
    path: "/tr/introduction/appointment",
    component: _c61b0754,
    name: "introduction-appointment___tr"
  }, {
    path: "/tr/introduction/calendar",
    component: _06039406,
    name: "introduction-calendar___tr"
  }, {
    path: "/tr/introduction/schedule",
    component: _2a373216,
    name: "introduction-schedule___tr"
  }, {
    path: "/tr/introduction/terms",
    component: _81bac584,
    name: "introduction-terms___tr"
  }, {
    path: "/tr/introduction/welcome",
    component: _02e29b4e,
    name: "introduction-welcome___tr"
  }, {
    path: "/tr/invite/accepted",
    component: _6f476f17,
    name: "invite-accepted___tr"
  }, {
    path: "/tr/invite/declined",
    component: _0f2e0ede,
    name: "invite-declined___tr"
  }, {
    path: "/tr/invite/unavailable",
    component: _ebbe0b94,
    name: "invite-unavailable___tr"
  }, {
    path: "/tr/settings/applications",
    component: _ece6c214,
    name: "settings-applications___tr"
  }, {
    path: "/tr/settings/calendar",
    component: _6497f5de,
    name: "settings-calendar___tr"
  }, {
    path: "/tr/settings/houses",
    component: _6cbd3134,
    name: "settings-houses___tr"
  }, {
    path: "/tr/settings/member-benefits",
    component: _7373690c,
    name: "settings-member-benefits___tr"
  }, {
    path: "/tr/settings/membership",
    component: _2cb9e2e9,
    name: "settings-membership___tr"
  }, {
    path: "/tr/settings/password",
    component: _0485cdee,
    name: "settings-password___tr"
  }, {
    path: "/tr/settings/payment",
    component: _77f65046,
    name: "settings-payment___tr"
  }, {
    path: "/tr/settings/preferences",
    component: _bbdf7d16,
    name: "settings-preferences___tr"
  }, {
    path: "/tr/settings/previous-bookings",
    component: _0792680d,
    name: "settings-previous-bookings___tr"
  }, {
    path: "/tr/settings/profile",
    component: _0dde33b4,
    name: "settings-profile___tr"
  }, {
    path: "/zh/account/create",
    component: _315062ec,
    name: "account-create___zh"
  }, {
    path: "/zh/account/expired",
    component: _4f8180ed,
    name: "account-expired___zh"
  }, {
    path: "/zh/account/frozen",
    component: _7224832e,
    name: "account-frozen___zh"
  }, {
    path: "/zh/account/not-active",
    component: _c10f9b64,
    name: "account-not-active___zh"
  }, {
    path: "/zh/account/overdue",
    component: _6798b6b0,
    name: "account-overdue___zh"
  }, {
    path: "/zh/account/suspended",
    component: _456c74e3,
    name: "account-suspended___zh"
  }, {
    path: "/zh/account/verified",
    component: _19ec26d4,
    name: "account-verified___zh"
  }, {
    path: "/zh/account/verify",
    component: _37893dc7,
    name: "account-verify___zh"
  }, {
    path: "/zh/apply/submitted",
    component: _2cc2e2f8,
    name: "apply-submitted___zh"
  }, {
    path: "/zh/auth/login",
    component: _6ae3e14e,
    name: "oauth-login___zh"
  }, {
    path: "/zh/auth/logout",
    component: _6ae3e14e,
    name: "oauth-logout___zh"
  }, {
    path: "/zh/bedrooms/availability",
    component: _f2bbfc86,
    name: "bedrooms-availability___zh"
  }, {
    path: "/zh/bedrooms/search",
    component: _6c7eb1ec,
    name: "bedrooms-search___zh"
  }, {
    path: "/zh/introduction/analytics",
    component: _8490a306,
    name: "introduction-analytics___zh"
  }, {
    path: "/zh/introduction/appointment",
    component: _c61b0754,
    name: "introduction-appointment___zh"
  }, {
    path: "/zh/introduction/calendar",
    component: _06039406,
    name: "introduction-calendar___zh"
  }, {
    path: "/zh/introduction/schedule",
    component: _2a373216,
    name: "introduction-schedule___zh"
  }, {
    path: "/zh/introduction/terms",
    component: _81bac584,
    name: "introduction-terms___zh"
  }, {
    path: "/zh/introduction/welcome",
    component: _02e29b4e,
    name: "introduction-welcome___zh"
  }, {
    path: "/zh/invite/accepted",
    component: _6f476f17,
    name: "invite-accepted___zh"
  }, {
    path: "/zh/invite/declined",
    component: _0f2e0ede,
    name: "invite-declined___zh"
  }, {
    path: "/zh/invite/unavailable",
    component: _ebbe0b94,
    name: "invite-unavailable___zh"
  }, {
    path: "/zh/settings/applications",
    component: _ece6c214,
    name: "settings-applications___zh"
  }, {
    path: "/zh/settings/calendar",
    component: _6497f5de,
    name: "settings-calendar___zh"
  }, {
    path: "/zh/settings/houses",
    component: _6cbd3134,
    name: "settings-houses___zh"
  }, {
    path: "/zh/settings/member-benefits",
    component: _7373690c,
    name: "settings-member-benefits___zh"
  }, {
    path: "/zh/settings/membership",
    component: _2cb9e2e9,
    name: "settings-membership___zh"
  }, {
    path: "/zh/settings/password",
    component: _0485cdee,
    name: "settings-password___zh"
  }, {
    path: "/zh/settings/payment",
    component: _77f65046,
    name: "settings-payment___zh"
  }, {
    path: "/zh/settings/preferences",
    component: _bbdf7d16,
    name: "settings-preferences___zh"
  }, {
    path: "/zh/settings/previous-bookings",
    component: _0792680d,
    name: "settings-previous-bookings___zh"
  }, {
    path: "/zh/settings/profile",
    component: _0dde33b4,
    name: "settings-profile___zh"
  }, {
    path: "/ca/account/verify/expired",
    component: _d493db46,
    name: "account-verify-expired___ca"
  }, {
    path: "/ca/account/verify/resend",
    component: _7dcd10ce,
    name: "account-verify-resend___ca"
  }, {
    path: "/ca/bedrooms/availability/book",
    component: _bec3e15e,
    name: "bedrooms-availability-book___ca"
  }, {
    path: "/ca/settings/payment/add-method",
    component: _bc9131e8,
    name: "settings-payment-add-method___ca"
  }, {
    path: "/ca/settings/payment/callback",
    component: _ac104278,
    name: "settings-payment-callback___ca"
  }, {
    path: "/de/account/verify/expired",
    component: _d493db46,
    name: "account-verify-expired___de"
  }, {
    path: "/de/account/verify/resend",
    component: _7dcd10ce,
    name: "account-verify-resend___de"
  }, {
    path: "/de/bedrooms/availability/book",
    component: _bec3e15e,
    name: "bedrooms-availability-book___de"
  }, {
    path: "/de/settings/payment/add-method",
    component: _bc9131e8,
    name: "settings-payment-add-method___de"
  }, {
    path: "/de/settings/payment/callback",
    component: _ac104278,
    name: "settings-payment-callback___de"
  }, {
    path: "/en-us/account/verify/expired",
    component: _d493db46,
    name: "account-verify-expired___en-us"
  }, {
    path: "/en-us/account/verify/resend",
    component: _7dcd10ce,
    name: "account-verify-resend___en-us"
  }, {
    path: "/en-us/bedrooms/availability/book",
    component: _bec3e15e,
    name: "bedrooms-availability-book___en-us"
  }, {
    path: "/en-us/settings/payment/add-method",
    component: _bc9131e8,
    name: "settings-payment-add-method___en-us"
  }, {
    path: "/en-us/settings/payment/callback",
    component: _ac104278,
    name: "settings-payment-callback___en-us"
  }, {
    path: "/es/account/verify/expired",
    component: _d493db46,
    name: "account-verify-expired___es"
  }, {
    path: "/es/account/verify/resend",
    component: _7dcd10ce,
    name: "account-verify-resend___es"
  }, {
    path: "/es/bedrooms/availability/book",
    component: _bec3e15e,
    name: "bedrooms-availability-book___es"
  }, {
    path: "/es/settings/payment/add-method",
    component: _bc9131e8,
    name: "settings-payment-add-method___es"
  }, {
    path: "/es/settings/payment/callback",
    component: _ac104278,
    name: "settings-payment-callback___es"
  }, {
    path: "/fr/account/verify/expired",
    component: _d493db46,
    name: "account-verify-expired___fr"
  }, {
    path: "/fr/account/verify/resend",
    component: _7dcd10ce,
    name: "account-verify-resend___fr"
  }, {
    path: "/fr/bedrooms/availability/book",
    component: _bec3e15e,
    name: "bedrooms-availability-book___fr"
  }, {
    path: "/fr/settings/payment/add-method",
    component: _bc9131e8,
    name: "settings-payment-add-method___fr"
  }, {
    path: "/fr/settings/payment/callback",
    component: _ac104278,
    name: "settings-payment-callback___fr"
  }, {
    path: "/ja/account/verify/expired",
    component: _d493db46,
    name: "account-verify-expired___ja"
  }, {
    path: "/ja/account/verify/resend",
    component: _7dcd10ce,
    name: "account-verify-resend___ja"
  }, {
    path: "/ja/bedrooms/availability/book",
    component: _bec3e15e,
    name: "bedrooms-availability-book___ja"
  }, {
    path: "/ja/settings/payment/add-method",
    component: _bc9131e8,
    name: "settings-payment-add-method___ja"
  }, {
    path: "/ja/settings/payment/callback",
    component: _ac104278,
    name: "settings-payment-callback___ja"
  }, {
    path: "/ko/account/verify/expired",
    component: _d493db46,
    name: "account-verify-expired___ko"
  }, {
    path: "/ko/account/verify/resend",
    component: _7dcd10ce,
    name: "account-verify-resend___ko"
  }, {
    path: "/ko/bedrooms/availability/book",
    component: _bec3e15e,
    name: "bedrooms-availability-book___ko"
  }, {
    path: "/ko/settings/payment/add-method",
    component: _bc9131e8,
    name: "settings-payment-add-method___ko"
  }, {
    path: "/ko/settings/payment/callback",
    component: _ac104278,
    name: "settings-payment-callback___ko"
  }, {
    path: "/tr/account/verify/expired",
    component: _d493db46,
    name: "account-verify-expired___tr"
  }, {
    path: "/tr/account/verify/resend",
    component: _7dcd10ce,
    name: "account-verify-resend___tr"
  }, {
    path: "/tr/bedrooms/availability/book",
    component: _bec3e15e,
    name: "bedrooms-availability-book___tr"
  }, {
    path: "/tr/settings/payment/add-method",
    component: _bc9131e8,
    name: "settings-payment-add-method___tr"
  }, {
    path: "/tr/settings/payment/callback",
    component: _ac104278,
    name: "settings-payment-callback___tr"
  }, {
    path: "/zh/account/verify/expired",
    component: _d493db46,
    name: "account-verify-expired___zh"
  }, {
    path: "/zh/account/verify/resend",
    component: _7dcd10ce,
    name: "account-verify-resend___zh"
  }, {
    path: "/zh/bedrooms/availability/book",
    component: _bec3e15e,
    name: "bedrooms-availability-book___zh"
  }, {
    path: "/zh/settings/payment/add-method",
    component: _bc9131e8,
    name: "settings-payment-add-method___zh"
  }, {
    path: "/zh/settings/payment/callback",
    component: _ac104278,
    name: "settings-payment-callback___zh"
  }, {
    path: "/ca/bedrooms/bookings/:id",
    component: _02218d47,
    name: "bedrooms-bookings-id___ca"
  }, {
    path: "/ca/bedrooms/promotion/:id",
    component: _279f45c2,
    name: "bedrooms-promotion-id___ca"
  }, {
    path: "/ca/whats-on/details/:id",
    component: _216f0bf2,
    name: "whats-on-details-id___ca"
  }, {
    path: "/de/bedrooms/bookings/:id",
    component: _02218d47,
    name: "bedrooms-bookings-id___de"
  }, {
    path: "/de/bedrooms/promotion/:id",
    component: _279f45c2,
    name: "bedrooms-promotion-id___de"
  }, {
    path: "/de/whats-on/details/:id",
    component: _216f0bf2,
    name: "whats-on-details-id___de"
  }, {
    path: "/en-us/bedrooms/bookings/:id",
    component: _02218d47,
    name: "bedrooms-bookings-id___en-us"
  }, {
    path: "/en-us/bedrooms/promotion/:id",
    component: _279f45c2,
    name: "bedrooms-promotion-id___en-us"
  }, {
    path: "/en-us/whats-on/details/:id",
    component: _216f0bf2,
    name: "whats-on-details-id___en-us"
  }, {
    path: "/es/bedrooms/bookings/:id",
    component: _02218d47,
    name: "bedrooms-bookings-id___es"
  }, {
    path: "/es/bedrooms/promotion/:id",
    component: _279f45c2,
    name: "bedrooms-promotion-id___es"
  }, {
    path: "/es/whats-on/details/:id",
    component: _216f0bf2,
    name: "whats-on-details-id___es"
  }, {
    path: "/fr/bedrooms/bookings/:id",
    component: _02218d47,
    name: "bedrooms-bookings-id___fr"
  }, {
    path: "/fr/bedrooms/promotion/:id",
    component: _279f45c2,
    name: "bedrooms-promotion-id___fr"
  }, {
    path: "/fr/whats-on/details/:id",
    component: _216f0bf2,
    name: "whats-on-details-id___fr"
  }, {
    path: "/ja/bedrooms/bookings/:id",
    component: _02218d47,
    name: "bedrooms-bookings-id___ja"
  }, {
    path: "/ja/bedrooms/promotion/:id",
    component: _279f45c2,
    name: "bedrooms-promotion-id___ja"
  }, {
    path: "/ja/whats-on/details/:id",
    component: _216f0bf2,
    name: "whats-on-details-id___ja"
  }, {
    path: "/ko/bedrooms/bookings/:id",
    component: _02218d47,
    name: "bedrooms-bookings-id___ko"
  }, {
    path: "/ko/bedrooms/promotion/:id",
    component: _279f45c2,
    name: "bedrooms-promotion-id___ko"
  }, {
    path: "/ko/whats-on/details/:id",
    component: _216f0bf2,
    name: "whats-on-details-id___ko"
  }, {
    path: "/tr/bedrooms/bookings/:id",
    component: _02218d47,
    name: "bedrooms-bookings-id___tr"
  }, {
    path: "/tr/bedrooms/promotion/:id",
    component: _279f45c2,
    name: "bedrooms-promotion-id___tr"
  }, {
    path: "/tr/whats-on/details/:id",
    component: _216f0bf2,
    name: "whats-on-details-id___tr"
  }, {
    path: "/zh/bedrooms/bookings/:id",
    component: _02218d47,
    name: "bedrooms-bookings-id___zh"
  }, {
    path: "/zh/bedrooms/promotion/:id",
    component: _279f45c2,
    name: "bedrooms-promotion-id___zh"
  }, {
    path: "/zh/whats-on/details/:id",
    component: _216f0bf2,
    name: "whats-on-details-id___zh"
  }, {
    path: "/ca/bedrooms/bookings/:id?/cancel",
    component: _4582d798,
    name: "bedrooms-bookings-id-cancel___ca"
  }, {
    path: "/ca/bedrooms/bookings/:id?/modify",
    component: _5aec51d8,
    name: "bedrooms-bookings-id-modify___ca"
  }, {
    path: "/de/bedrooms/bookings/:id?/cancel",
    component: _4582d798,
    name: "bedrooms-bookings-id-cancel___de"
  }, {
    path: "/de/bedrooms/bookings/:id?/modify",
    component: _5aec51d8,
    name: "bedrooms-bookings-id-modify___de"
  }, {
    path: "/en-us/bedrooms/bookings/:id?/cancel",
    component: _4582d798,
    name: "bedrooms-bookings-id-cancel___en-us"
  }, {
    path: "/en-us/bedrooms/bookings/:id?/modify",
    component: _5aec51d8,
    name: "bedrooms-bookings-id-modify___en-us"
  }, {
    path: "/es/bedrooms/bookings/:id?/cancel",
    component: _4582d798,
    name: "bedrooms-bookings-id-cancel___es"
  }, {
    path: "/es/bedrooms/bookings/:id?/modify",
    component: _5aec51d8,
    name: "bedrooms-bookings-id-modify___es"
  }, {
    path: "/fr/bedrooms/bookings/:id?/cancel",
    component: _4582d798,
    name: "bedrooms-bookings-id-cancel___fr"
  }, {
    path: "/fr/bedrooms/bookings/:id?/modify",
    component: _5aec51d8,
    name: "bedrooms-bookings-id-modify___fr"
  }, {
    path: "/ja/bedrooms/bookings/:id?/cancel",
    component: _4582d798,
    name: "bedrooms-bookings-id-cancel___ja"
  }, {
    path: "/ja/bedrooms/bookings/:id?/modify",
    component: _5aec51d8,
    name: "bedrooms-bookings-id-modify___ja"
  }, {
    path: "/ko/bedrooms/bookings/:id?/cancel",
    component: _4582d798,
    name: "bedrooms-bookings-id-cancel___ko"
  }, {
    path: "/ko/bedrooms/bookings/:id?/modify",
    component: _5aec51d8,
    name: "bedrooms-bookings-id-modify___ko"
  }, {
    path: "/tr/bedrooms/bookings/:id?/cancel",
    component: _4582d798,
    name: "bedrooms-bookings-id-cancel___tr"
  }, {
    path: "/tr/bedrooms/bookings/:id?/modify",
    component: _5aec51d8,
    name: "bedrooms-bookings-id-modify___tr"
  }, {
    path: "/zh/bedrooms/bookings/:id?/cancel",
    component: _4582d798,
    name: "bedrooms-bookings-id-cancel___zh"
  }, {
    path: "/zh/bedrooms/bookings/:id?/modify",
    component: _5aec51d8,
    name: "bedrooms-bookings-id-modify___zh"
  }, {
    path: "/ca/bedrooms/bookings/:id?/cancel/cancelled",
    component: _2b9df2da,
    name: "bedrooms-bookings-id-cancel-cancelled___ca"
  }, {
    path: "/ca/bedrooms/bookings/:id?/modify/availability",
    component: _7e3fcbf0,
    name: "bedrooms-bookings-id-modify-availability___ca"
  }, {
    path: "/de/bedrooms/bookings/:id?/cancel/cancelled",
    component: _2b9df2da,
    name: "bedrooms-bookings-id-cancel-cancelled___de"
  }, {
    path: "/de/bedrooms/bookings/:id?/modify/availability",
    component: _7e3fcbf0,
    name: "bedrooms-bookings-id-modify-availability___de"
  }, {
    path: "/en-us/bedrooms/bookings/:id?/cancel/cancelled",
    component: _2b9df2da,
    name: "bedrooms-bookings-id-cancel-cancelled___en-us"
  }, {
    path: "/en-us/bedrooms/bookings/:id?/modify/availability",
    component: _7e3fcbf0,
    name: "bedrooms-bookings-id-modify-availability___en-us"
  }, {
    path: "/es/bedrooms/bookings/:id?/cancel/cancelled",
    component: _2b9df2da,
    name: "bedrooms-bookings-id-cancel-cancelled___es"
  }, {
    path: "/es/bedrooms/bookings/:id?/modify/availability",
    component: _7e3fcbf0,
    name: "bedrooms-bookings-id-modify-availability___es"
  }, {
    path: "/fr/bedrooms/bookings/:id?/cancel/cancelled",
    component: _2b9df2da,
    name: "bedrooms-bookings-id-cancel-cancelled___fr"
  }, {
    path: "/fr/bedrooms/bookings/:id?/modify/availability",
    component: _7e3fcbf0,
    name: "bedrooms-bookings-id-modify-availability___fr"
  }, {
    path: "/ja/bedrooms/bookings/:id?/cancel/cancelled",
    component: _2b9df2da,
    name: "bedrooms-bookings-id-cancel-cancelled___ja"
  }, {
    path: "/ja/bedrooms/bookings/:id?/modify/availability",
    component: _7e3fcbf0,
    name: "bedrooms-bookings-id-modify-availability___ja"
  }, {
    path: "/ko/bedrooms/bookings/:id?/cancel/cancelled",
    component: _2b9df2da,
    name: "bedrooms-bookings-id-cancel-cancelled___ko"
  }, {
    path: "/ko/bedrooms/bookings/:id?/modify/availability",
    component: _7e3fcbf0,
    name: "bedrooms-bookings-id-modify-availability___ko"
  }, {
    path: "/tr/bedrooms/bookings/:id?/cancel/cancelled",
    component: _2b9df2da,
    name: "bedrooms-bookings-id-cancel-cancelled___tr"
  }, {
    path: "/tr/bedrooms/bookings/:id?/modify/availability",
    component: _7e3fcbf0,
    name: "bedrooms-bookings-id-modify-availability___tr"
  }, {
    path: "/zh/bedrooms/bookings/:id?/cancel/cancelled",
    component: _2b9df2da,
    name: "bedrooms-bookings-id-cancel-cancelled___zh"
  }, {
    path: "/zh/bedrooms/bookings/:id?/modify/availability",
    component: _7e3fcbf0,
    name: "bedrooms-bookings-id-modify-availability___zh"
  }, {
    path: "/ca/bedrooms/bookings/:id?/modify/availability/book",
    component: _dd2b2434,
    name: "bedrooms-bookings-id-modify-availability-book___ca"
  }, {
    path: "/de/bedrooms/bookings/:id?/modify/availability/book",
    component: _dd2b2434,
    name: "bedrooms-bookings-id-modify-availability-book___de"
  }, {
    path: "/en-us/bedrooms/bookings/:id?/modify/availability/book",
    component: _dd2b2434,
    name: "bedrooms-bookings-id-modify-availability-book___en-us"
  }, {
    path: "/es/bedrooms/bookings/:id?/modify/availability/book",
    component: _dd2b2434,
    name: "bedrooms-bookings-id-modify-availability-book___es"
  }, {
    path: "/fr/bedrooms/bookings/:id?/modify/availability/book",
    component: _dd2b2434,
    name: "bedrooms-bookings-id-modify-availability-book___fr"
  }, {
    path: "/ja/bedrooms/bookings/:id?/modify/availability/book",
    component: _dd2b2434,
    name: "bedrooms-bookings-id-modify-availability-book___ja"
  }, {
    path: "/ko/bedrooms/bookings/:id?/modify/availability/book",
    component: _dd2b2434,
    name: "bedrooms-bookings-id-modify-availability-book___ko"
  }, {
    path: "/tr/bedrooms/bookings/:id?/modify/availability/book",
    component: _dd2b2434,
    name: "bedrooms-bookings-id-modify-availability-book___tr"
  }, {
    path: "/zh/bedrooms/bookings/:id?/modify/availability/book",
    component: _dd2b2434,
    name: "bedrooms-bookings-id-modify-availability-book___zh"
  }, {
    path: "/bedrooms/bookings/:id",
    component: _02218d47,
    name: "bedrooms-bookings-id___en"
  }, {
    path: "/bedrooms/promotion/:id",
    component: _279f45c2,
    name: "bedrooms-promotion-id___en"
  }, {
    path: "/ca/invite/:id",
    component: _3db85220,
    name: "invite-id___ca"
  }, {
    path: "/ca/member-benefits/:id",
    component: _efbe48b8,
    name: "member-benefits-id___ca"
  }, {
    path: "/ca/whats-on/:type",
    component: _2c6805f3,
    name: "whats-on-type___ca"
  }, {
    path: "/de/invite/:id",
    component: _3db85220,
    name: "invite-id___de"
  }, {
    path: "/de/member-benefits/:id",
    component: _efbe48b8,
    name: "member-benefits-id___de"
  }, {
    path: "/de/whats-on/:type",
    component: _2c6805f3,
    name: "whats-on-type___de"
  }, {
    path: "/en-us/invite/:id",
    component: _3db85220,
    name: "invite-id___en-us"
  }, {
    path: "/en-us/member-benefits/:id",
    component: _efbe48b8,
    name: "member-benefits-id___en-us"
  }, {
    path: "/en-us/whats-on/:type",
    component: _2c6805f3,
    name: "whats-on-type___en-us"
  }, {
    path: "/es/invite/:id",
    component: _3db85220,
    name: "invite-id___es"
  }, {
    path: "/es/member-benefits/:id",
    component: _efbe48b8,
    name: "member-benefits-id___es"
  }, {
    path: "/es/whats-on/:type",
    component: _2c6805f3,
    name: "whats-on-type___es"
  }, {
    path: "/fr/invite/:id",
    component: _3db85220,
    name: "invite-id___fr"
  }, {
    path: "/fr/member-benefits/:id",
    component: _efbe48b8,
    name: "member-benefits-id___fr"
  }, {
    path: "/fr/whats-on/:type",
    component: _2c6805f3,
    name: "whats-on-type___fr"
  }, {
    path: "/ja/invite/:id",
    component: _3db85220,
    name: "invite-id___ja"
  }, {
    path: "/ja/member-benefits/:id",
    component: _efbe48b8,
    name: "member-benefits-id___ja"
  }, {
    path: "/ja/whats-on/:type",
    component: _2c6805f3,
    name: "whats-on-type___ja"
  }, {
    path: "/ko/invite/:id",
    component: _3db85220,
    name: "invite-id___ko"
  }, {
    path: "/ko/member-benefits/:id",
    component: _efbe48b8,
    name: "member-benefits-id___ko"
  }, {
    path: "/ko/whats-on/:type",
    component: _2c6805f3,
    name: "whats-on-type___ko"
  }, {
    path: "/tr/invite/:id",
    component: _3db85220,
    name: "invite-id___tr"
  }, {
    path: "/tr/member-benefits/:id",
    component: _efbe48b8,
    name: "member-benefits-id___tr"
  }, {
    path: "/tr/whats-on/:type",
    component: _2c6805f3,
    name: "whats-on-type___tr"
  }, {
    path: "/whats-on/details/:id",
    component: _216f0bf2,
    name: "whats-on-details-id___en"
  }, {
    path: "/zh/invite/:id",
    component: _3db85220,
    name: "invite-id___zh"
  }, {
    path: "/zh/member-benefits/:id",
    component: _efbe48b8,
    name: "member-benefits-id___zh"
  }, {
    path: "/zh/whats-on/:type",
    component: _2c6805f3,
    name: "whats-on-type___zh"
  }, {
    path: "/bedrooms/bookings/:id?/cancel",
    component: _4582d798,
    name: "bedrooms-bookings-id-cancel___en"
  }, {
    path: "/bedrooms/bookings/:id?/modify",
    component: _5aec51d8,
    name: "bedrooms-bookings-id-modify___en"
  }, {
    path: "/ca/apply/:id/basics",
    component: _d80c47b2,
    name: "apply-id-basics___ca"
  }, {
    path: "/ca/apply/:id/details",
    component: _699c5b14,
    name: "apply-id-details___ca"
  }, {
    path: "/ca/apply/:id/package",
    component: _28e65f7a,
    name: "apply-id-package___ca"
  }, {
    path: "/ca/apply/:id/pay",
    component: _02e00448,
    name: "apply-id-pay___ca"
  }, {
    path: "/ca/apply/:id/review",
    component: _1d14d5ba,
    name: "apply-id-review___ca"
  }, {
    path: "/ca/apply/:id/rules",
    component: _1d49c5aa,
    name: "apply-id-rules___ca"
  }, {
    path: "/ca/invite/:id?/landing",
    component: _562bca28,
    name: "invite-id-landing___ca"
  }, {
    path: "/de/apply/:id/basics",
    component: _d80c47b2,
    name: "apply-id-basics___de"
  }, {
    path: "/de/apply/:id/details",
    component: _699c5b14,
    name: "apply-id-details___de"
  }, {
    path: "/de/apply/:id/package",
    component: _28e65f7a,
    name: "apply-id-package___de"
  }, {
    path: "/de/apply/:id/pay",
    component: _02e00448,
    name: "apply-id-pay___de"
  }, {
    path: "/de/apply/:id/review",
    component: _1d14d5ba,
    name: "apply-id-review___de"
  }, {
    path: "/de/apply/:id/rules",
    component: _1d49c5aa,
    name: "apply-id-rules___de"
  }, {
    path: "/de/invite/:id?/landing",
    component: _562bca28,
    name: "invite-id-landing___de"
  }, {
    path: "/en-us/apply/:id/basics",
    component: _d80c47b2,
    name: "apply-id-basics___en-us"
  }, {
    path: "/en-us/apply/:id/details",
    component: _699c5b14,
    name: "apply-id-details___en-us"
  }, {
    path: "/en-us/apply/:id/package",
    component: _28e65f7a,
    name: "apply-id-package___en-us"
  }, {
    path: "/en-us/apply/:id/pay",
    component: _02e00448,
    name: "apply-id-pay___en-us"
  }, {
    path: "/en-us/apply/:id/review",
    component: _1d14d5ba,
    name: "apply-id-review___en-us"
  }, {
    path: "/en-us/apply/:id/rules",
    component: _1d49c5aa,
    name: "apply-id-rules___en-us"
  }, {
    path: "/en-us/invite/:id?/landing",
    component: _562bca28,
    name: "invite-id-landing___en-us"
  }, {
    path: "/es/apply/:id/basics",
    component: _d80c47b2,
    name: "apply-id-basics___es"
  }, {
    path: "/es/apply/:id/details",
    component: _699c5b14,
    name: "apply-id-details___es"
  }, {
    path: "/es/apply/:id/package",
    component: _28e65f7a,
    name: "apply-id-package___es"
  }, {
    path: "/es/apply/:id/pay",
    component: _02e00448,
    name: "apply-id-pay___es"
  }, {
    path: "/es/apply/:id/review",
    component: _1d14d5ba,
    name: "apply-id-review___es"
  }, {
    path: "/es/apply/:id/rules",
    component: _1d49c5aa,
    name: "apply-id-rules___es"
  }, {
    path: "/es/invite/:id?/landing",
    component: _562bca28,
    name: "invite-id-landing___es"
  }, {
    path: "/fr/apply/:id/basics",
    component: _d80c47b2,
    name: "apply-id-basics___fr"
  }, {
    path: "/fr/apply/:id/details",
    component: _699c5b14,
    name: "apply-id-details___fr"
  }, {
    path: "/fr/apply/:id/package",
    component: _28e65f7a,
    name: "apply-id-package___fr"
  }, {
    path: "/fr/apply/:id/pay",
    component: _02e00448,
    name: "apply-id-pay___fr"
  }, {
    path: "/fr/apply/:id/review",
    component: _1d14d5ba,
    name: "apply-id-review___fr"
  }, {
    path: "/fr/apply/:id/rules",
    component: _1d49c5aa,
    name: "apply-id-rules___fr"
  }, {
    path: "/fr/invite/:id?/landing",
    component: _562bca28,
    name: "invite-id-landing___fr"
  }, {
    path: "/ja/apply/:id/basics",
    component: _d80c47b2,
    name: "apply-id-basics___ja"
  }, {
    path: "/ja/apply/:id/details",
    component: _699c5b14,
    name: "apply-id-details___ja"
  }, {
    path: "/ja/apply/:id/package",
    component: _28e65f7a,
    name: "apply-id-package___ja"
  }, {
    path: "/ja/apply/:id/pay",
    component: _02e00448,
    name: "apply-id-pay___ja"
  }, {
    path: "/ja/apply/:id/review",
    component: _1d14d5ba,
    name: "apply-id-review___ja"
  }, {
    path: "/ja/apply/:id/rules",
    component: _1d49c5aa,
    name: "apply-id-rules___ja"
  }, {
    path: "/ja/invite/:id?/landing",
    component: _562bca28,
    name: "invite-id-landing___ja"
  }, {
    path: "/ko/apply/:id/basics",
    component: _d80c47b2,
    name: "apply-id-basics___ko"
  }, {
    path: "/ko/apply/:id/details",
    component: _699c5b14,
    name: "apply-id-details___ko"
  }, {
    path: "/ko/apply/:id/package",
    component: _28e65f7a,
    name: "apply-id-package___ko"
  }, {
    path: "/ko/apply/:id/pay",
    component: _02e00448,
    name: "apply-id-pay___ko"
  }, {
    path: "/ko/apply/:id/review",
    component: _1d14d5ba,
    name: "apply-id-review___ko"
  }, {
    path: "/ko/apply/:id/rules",
    component: _1d49c5aa,
    name: "apply-id-rules___ko"
  }, {
    path: "/ko/invite/:id?/landing",
    component: _562bca28,
    name: "invite-id-landing___ko"
  }, {
    path: "/tr/apply/:id/basics",
    component: _d80c47b2,
    name: "apply-id-basics___tr"
  }, {
    path: "/tr/apply/:id/details",
    component: _699c5b14,
    name: "apply-id-details___tr"
  }, {
    path: "/tr/apply/:id/package",
    component: _28e65f7a,
    name: "apply-id-package___tr"
  }, {
    path: "/tr/apply/:id/pay",
    component: _02e00448,
    name: "apply-id-pay___tr"
  }, {
    path: "/tr/apply/:id/review",
    component: _1d14d5ba,
    name: "apply-id-review___tr"
  }, {
    path: "/tr/apply/:id/rules",
    component: _1d49c5aa,
    name: "apply-id-rules___tr"
  }, {
    path: "/tr/invite/:id?/landing",
    component: _562bca28,
    name: "invite-id-landing___tr"
  }, {
    path: "/zh/apply/:id/basics",
    component: _d80c47b2,
    name: "apply-id-basics___zh"
  }, {
    path: "/zh/apply/:id/details",
    component: _699c5b14,
    name: "apply-id-details___zh"
  }, {
    path: "/zh/apply/:id/package",
    component: _28e65f7a,
    name: "apply-id-package___zh"
  }, {
    path: "/zh/apply/:id/pay",
    component: _02e00448,
    name: "apply-id-pay___zh"
  }, {
    path: "/zh/apply/:id/review",
    component: _1d14d5ba,
    name: "apply-id-review___zh"
  }, {
    path: "/zh/apply/:id/rules",
    component: _1d49c5aa,
    name: "apply-id-rules___zh"
  }, {
    path: "/zh/invite/:id?/landing",
    component: _562bca28,
    name: "invite-id-landing___zh"
  }, {
    path: "/bedrooms/bookings/:id?/cancel/cancelled",
    component: _2b9df2da,
    name: "bedrooms-bookings-id-cancel-cancelled___en"
  }, {
    path: "/bedrooms/bookings/:id?/modify/availability",
    component: _7e3fcbf0,
    name: "bedrooms-bookings-id-modify-availability___en"
  }, {
    path: "/ca/apply/:id/pay/callback",
    component: _43f919ee,
    name: "apply-id-pay-callback___ca"
  }, {
    path: "/de/apply/:id/pay/callback",
    component: _43f919ee,
    name: "apply-id-pay-callback___de"
  }, {
    path: "/en-us/apply/:id/pay/callback",
    component: _43f919ee,
    name: "apply-id-pay-callback___en-us"
  }, {
    path: "/es/apply/:id/pay/callback",
    component: _43f919ee,
    name: "apply-id-pay-callback___es"
  }, {
    path: "/fr/apply/:id/pay/callback",
    component: _43f919ee,
    name: "apply-id-pay-callback___fr"
  }, {
    path: "/ja/apply/:id/pay/callback",
    component: _43f919ee,
    name: "apply-id-pay-callback___ja"
  }, {
    path: "/ko/apply/:id/pay/callback",
    component: _43f919ee,
    name: "apply-id-pay-callback___ko"
  }, {
    path: "/tr/apply/:id/pay/callback",
    component: _43f919ee,
    name: "apply-id-pay-callback___tr"
  }, {
    path: "/zh/apply/:id/pay/callback",
    component: _43f919ee,
    name: "apply-id-pay-callback___zh"
  }, {
    path: "/bedrooms/bookings/:id?/modify/availability/book",
    component: _dd2b2434,
    name: "bedrooms-bookings-id-modify-availability-book___en"
  }, {
    path: "/invite/:id",
    component: _3db85220,
    name: "invite-id___en"
  }, {
    path: "/member-benefits/:id",
    component: _efbe48b8,
    name: "member-benefits-id___en"
  }, {
    path: "/whats-on/:type",
    component: _2c6805f3,
    name: "whats-on-type___en"
  }, {
    path: "/apply/:id/basics",
    component: _d80c47b2,
    name: "apply-id-basics___en"
  }, {
    path: "/apply/:id/details",
    component: _699c5b14,
    name: "apply-id-details___en"
  }, {
    path: "/apply/:id/package",
    component: _28e65f7a,
    name: "apply-id-package___en"
  }, {
    path: "/apply/:id/pay",
    component: _02e00448,
    name: "apply-id-pay___en"
  }, {
    path: "/apply/:id/review",
    component: _1d14d5ba,
    name: "apply-id-review___en"
  }, {
    path: "/apply/:id/rules",
    component: _1d49c5aa,
    name: "apply-id-rules___en"
  }, {
    path: "/invite/:id?/landing",
    component: _562bca28,
    name: "invite-id-landing___en"
  }, {
    path: "/apply/:id/pay/callback",
    component: _43f919ee,
    name: "apply-id-pay-callback___en"
  }, {
    path: "/ja/*",
    component: _2b6b8946,
    name: "all___ja"
  }, {
    path: "/de/*",
    component: _2b6b8946,
    name: "all___de"
  }, {
    path: "/en-us/*",
    component: _2b6b8946,
    name: "all___en-us"
  }, {
    path: "/ko/*",
    component: _2b6b8946,
    name: "all___ko"
  }, {
    path: "/ca/*",
    component: _2b6b8946,
    name: "all___ca"
  }, {
    path: "/zh/*",
    component: _2b6b8946,
    name: "all___zh"
  }, {
    path: "/tr/*",
    component: _2b6b8946,
    name: "all___tr"
  }, {
    path: "/es/*",
    component: _2b6b8946,
    name: "all___es"
  }, {
    path: "/fr/*",
    component: _2b6b8946,
    name: "all___fr"
  }, {
    path: "/*",
    component: _2b6b8946,
    name: "all___en"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
